import React, { useEffect, useRef, useState } from "react";

export default function OtpDialog({ open,
    mobileNumber, emailId,
    onClose, onSubmit }) {
    const [mobileOtp, setMobileOtp] = useState("");
    const [emailOtp, setEmailOtp] = useState("");
    const [errors, setErrors] = useState({});
    const dialogRef = useRef(null);

    useEffect(() => {
        if (open) {
            setMobileOtp("");
            setEmailOtp("");
            setErrors({});
            // focus first field on open
            setTimeout(() => {
                dialogRef.current?.querySelector("#mobile-otp")?.focus();
            }, 0);
        }
    }, [open]);

    if (!open) return null;

    const validateEmptyOtps = () => {
        const e = {};
        if (!mobileOtp.trim()) e.mobileOtp = "Mobile OTP is required.";
        if (!emailOtp.trim()) e.emailOtp = "Email OTP is required.";
        return e;
    };

    const handleSubmit = (ev) => {
        ev.preventDefault();
        const e = validateEmptyOtps();
        setErrors(e);
        if (Object.keys(e).length === 0) {
            onSubmit?.({ mobileOtp, emailOtp });
        }
    };

    return (
        <div
            onClick={onClose}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
            }}
            role="presentation"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby="otp-title"
                style={{
                    background: "#fff",            // white dialog
                    width: "min(520px, 92vw)",
                    borderRadius: 12,
                    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
                    padding: 16,
                    fontFamily:
                        'system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial',
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <h2 id="otp-title" style={{ margin: 0, fontSize: 18 }}>
                        Otp Verification!
                    </h2>
                    <button
                        type="button"
                        aria-label="Close"
                        onClick={onClose}
                        style={{
                            marginLeft: "auto",
                            border: "none",
                            background: "transparent",
                            fontSize: 22,
                            cursor: "pointer",
                            lineHeight: 1,
                        }}
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit} style={{ marginTop: 12 }}>
                    {/* Mobile OTP */}
                    <div style={{ marginBottom: 12 }}>
                        <label
                            htmlFor="mobile-otp"
                            style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
                        >
                            {`Mobile OTP(${mobileNumber})`}
                        </label>
                        <input
                            id="mobile-otp"
                            type="text"                   // no digit restriction
                            value={mobileOtp}
                            onChange={(e) => setMobileOtp(e.target.value)}
                            placeholder="Enter Mobile OTP"
                            style={{
                                width: "100%",
                                height: 44,
                                borderRadius: 8,
                                border: "1px solid #d1d5db",
                                padding: "0 12px",
                                fontSize: 16,
                                outline: "none",
                            }}
                        />
                        {errors.mobileOtp && (
                            <div style={{ color: "#b91c1c", fontSize: 13, marginTop: 6 }}>
                                {errors.mobileOtp}
                            </div>
                        )}
                    </div>

                    {/* Email OTP */}
                    <div style={{ marginBottom: 12 }}>
                        <label
                            htmlFor="email-otp"
                            style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
                        >
                            {`Email OTP(${emailId})`}
                        </label>
                        <input
                            id="email-otp"
                            type="text"                   // no digit restriction
                            value={emailOtp}
                            onChange={(e) => setEmailOtp(e.target.value)}
                            placeholder="Enter Email OTP"
                            style={{
                                width: "100%",
                                height: 44,
                                borderRadius: 8,
                                border: "1px solid #d1d5db",
                                padding: "0 12px",
                                fontSize: 16,
                                outline: "none",
                            }}
                        />
                        {errors.emailOtp && (
                            <div style={{ color: "#b91c1c", fontSize: 13, marginTop: 6 }}>
                                {errors.emailOtp}
                            </div>
                        )}
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 8 }}>
                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                padding: "10px 14px",
                                borderRadius: 8,
                                border: "1px solid #e5e7eb",
                                background: "#f3f4f6",
                                cursor: "pointer",
                                fontWeight: 600,
                                fontSize: 14,
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            style={{
                                padding: "10px 14px",
                                borderRadius: 8,
                                border: "none",
                                background: "#2563eb",
                                color: "#fff",
                                cursor: "pointer",
                                fontWeight: 600,
                                fontSize: 14,
                            }}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
